<ng-template appGalleryViewSmall></ng-template>
<ng-template appGalleryViewOrdered></ng-template>
<div class="gallery-drop-indicator"></div>
